<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { Icon } from '@/components/ui';
import { cn } from '@/lib/utils';
import type { Markets } from '@/types';

interface Props {
  category?: Markets[number];
  active?: boolean;
}

withDefaults(defineProps<Props>(), {
  category: 'agriculture',
});

const { t } = useI18n();
</script>

<template>
  <button
    :style="`--filler-50: var(--markets-${category})`"
    :class="
      cn(
        'group relative isolate flex max-h-10 min-h-10 w-0 min-w-10 max-w-fit select-none flex-nowrap items-center overflow-hidden rounded-3xl bg-white text-white ring-0 ring-white ring-offset-0 transition-[width_background-color] duration-300 ease-in-out hover:w-full hover:bg-filler-50 hover:ring-[2.5px] focus-visible:w-full focus-visible:bg-filler-50 focus-visible:ring-[2.5px]',
        active && 'bg-filler-50',
      )
    "
  >
    <span class="block whitespace-nowrap text-nowrap pl-5 pr-[calc(2.75rem_+_5px)] capitalize">
      {{ t(`global.categories.${category}`) }}
    </span>
    <div
      :class="[
        cn(
          'absolute right-0 z-10 rounded-full bg-white text-shuttle-gray-500 transition-[background-color_color] duration-500 group-hover:bg-filler-50 group-hover:text-white group-hover:brightness-110 group-focus-visible:bg-filler-50 group-focus-visible:text-white',
          active && 'bg-filler-50 text-white',
        ),
      ]"
    >
      <Icon class="size-10" :name="category" />
    </div>
  </button>
</template>
